import clsx from 'clsx';
import { ReactNode } from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { Link } from 'react-router-dom';

import { Heading } from '@/components/typography/heading';

import styles from './detailPageHeader.module.scss';

type Props = {
  backTo: string;
  backLabel: string;
  icon?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  backTestId?: string;
};

/**
 * Shared detail-page header: back pill, optional framed entity icon, title,
 * optional subtitle/description, and right-aligned actions. Used by the
 * evaluation source, runs, and compare detail pages.
 */
export function DetailPageHeader( { backTo, backLabel, icon, title, subtitle, description, actions, backTestId }: Props ) {
  return (
    <header className={ styles.header }>
      <Link to={ backTo } className={ styles.backLink } data-testid={ backTestId }>
        <FiArrowLeft aria-hidden="true" />
        <span>{ backLabel }</span>
      </Link>

      <div className={ clsx( 'layout__row', styles.titleRow ) }>
        { icon && (
          <span className={ styles.icon } aria-hidden="true">
            { icon }
          </span>
        ) }
        <div className={ styles.titleText }>
          <Heading as="h1" size="lg" className={ styles.title }>
            { title }
          </Heading>
          { subtitle && <p className={ styles.subtitle }>{ subtitle }</p> }
        </div>
        { actions && <div className={ styles.actions }>{ actions }</div> }
      </div>

      { description && <p className={ styles.description }>{ description }</p> }
    </header>
  );
}
